// Brand color palette
const colors = {
    primary: "#8404D9", // Vibrant violet-purple - main brand color
    secondary: "#BD30BF", // Bright magenta-purple - accent color
    accent: "#9407F2", // Medium purple - for highlights
    dark: "#5503A6", // Deep purple - for darker elements
    deepDark: "#48048C", // Dark indigo-purple - for very dark elements
    
    // UI supporting colors
    lightPurple: "#F2E6FF", // Very light purple for backgrounds
    mediumLightPurple: "#0041F0", // Medium light purple for hover states
    grayPurple: "#F5F0FF", // Gray with purple tint for neutral backgrounds
    textPrimary: "#1A0033", // Near-black with purple tint for main text
    textSecondary: "#5A4980", // Muted purple for secondary text
  };
  
  export default colors;